/* Riverbend: Xola date deep-link -> NATIVE Xola slide-out (x2 checkout).
   Acts ONLY when location.hash starts with "#book=". IIFE, no globals, addEventListener only.
   Uses Xola's own page API window.xola.checkout(buttonData, {arrival, arrivalTime}) from
   https://xola.com/checkout.js, which appends arrivalDate/arrivalTime to the x2 flow URL
   (https://x2-checkout.xola.app/flows/mvp_calendar?button=<exp>&arrivalDate=YYYY-MM-DD&arrivalTime=HMM).
   Fallbacks (never a new tab):
   - date missing/invalid/in the past (America/New_York), or the dated checkout call throws,
     or Xola isn't ready within 10s -> open the tour's normal (undated) slide-out as soon as Xola
     is ready: window.xola.checkout(buttonData) only, else click the page's own Book Now button.
   - Xola never loads (gives up after 60s) -> leave the page as-is.
   Note: a valid date with a time slot that doesn't exist opens the dated panel and Xola shows its own
   waitlist/unavailable notice inside the cross-domain iframe; that can't be detected from here. */
(function () {
  'use strict';
  var SELLER = '69ab3c02c622b40dd801be82';
  var TZ = 'America/New_York';
  var MAP = {
    'cow-pasture-tour': '6a986b40cf6ebc7da70e1995',
    'extended-ranch-tour': '69d56ada885deca5230abd7c',
    'farm-animal-tour': '69d56a3455e79bf71302c9e6'
  };
  var me = document.currentScript;
  var PAGE_HANDLE = (me && me.getAttribute('data-page-handle')) || '';
  var DATED_WAIT_MS = 10000, GIVE_UP_MS = 60000, STEP_MS = 100;
  var pending = 0; /* token so a newer hash cancels an older wait */

  function pad(n) { return (n < 10 ? '0' : '') + n; }

  /* Current wall-clock in America/New_York as "YYYY-MM-DDTHHmm" (sortable string). */
  function nowET() {
    try {
      var parts = {};
      new Intl.DateTimeFormat('en-US', { timeZone: TZ, year: 'numeric', month: '2-digit', day: '2-digit',
        hour: '2-digit', minute: '2-digit', hourCycle: 'h23' }).formatToParts(new Date())
        .forEach(function (p) { parts[p.type] = p.value; });
      return parts.year + '-' + parts.month + '-' + parts.day + 'T' + (parts.hour === '24' ? '00' : parts.hour) + parts.minute;
    } catch (e) { return null; }
  }

  function validDate(d, hhmm) {
    var y = +d.slice(0, 4), mo = +d.slice(5, 7), da = +d.slice(8, 10);
    var dt = new Date(Date.UTC(y, mo - 1, da));
    if (dt.getUTCFullYear() !== y || dt.getUTCMonth() !== mo - 1 || dt.getUTCDate() !== da) return false;
    if (hhmm && (+hhmm.slice(0, 2) > 23 || +hhmm.slice(2) > 59)) return false;
    return true;
  }

  function parseHash() {
    var h = location.hash || '';
    if (h.indexOf('#book=') !== 0) return null;
    var params = {};
    h.slice(1).split('&').forEach(function (p) {
      var i = p.indexOf('=');
      if (i > 0) { try { params[decodeURIComponent(p.slice(0, i))] = decodeURIComponent(p.slice(i + 1)); } catch (e) {} }
    });
    var exp = (params.exp && /^[a-f0-9]{24}$/i.test(params.exp)) ? params.exp.toLowerCase() : MAP[PAGE_HANDLE];
    if (!exp) return null;
    var b = { date: null, time: '', exp: exp };
    var m = /^(\d{4}-\d{2}-\d{2})(?:T(\d{4}))?$/.exec(params.book || '');
    if (!m || !validDate(m[1], m[2])) return b; /* invalid -> undated slide-out */
    var now = nowET();
    if (now) {
      var past = m[2] ? (m[1] + 'T' + m[2]) < now : m[1] < now.slice(0, 10);
      if (past) return b; /* past -> undated slide-out */
    }
    b.date = m[1];
    /* Xola timeslot times are integers (e.g. 1015, 900): "0900" -> "900" */
    b.time = m[2] ? String(parseInt(m[2], 10)) : '';
    return b;
  }

  function clearHash() {
    if ((location.hash || '').indexOf('#book=') === 0) {
      history.replaceState(history.state, '', location.pathname + location.search);
    }
  }

  function xolaReady() {
    var x = window.xola;
    return !!(x && typeof x.checkout === 'function' && x.fallBackUrl && document.body);
  }

  function buttonData(b) {
    return { type: 'experience', version: 2, seller: SELLER, experience: b.exp, theme: 'light' };
  }

  function openDated(b) {
    var opts = { arrival: b.date };
    if (b.time) opts.arrivalTime = b.time;
    /* No quantity passed on purpose: Xola puts any "quantity" on the FIRST demographic only. */
    window.xola.checkout(buttonData(b), opts);
  }

  /* The page's own Book Now element for this experience (Xola embed button), if any. */
  function findPageButton(exp) {
    var sel = '.xola-checkout, .xola-custom, [data-button-id], [data-experience]';
    var els = document.querySelectorAll(sel), first = null;
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      var e = el.getAttribute('data-experience') || el.getAttribute('data-experience-id') || '';
      if (e && e.toLowerCase() === exp) return el;
      if (!first && el.classList && el.classList.contains('xola-checkout')) first = el;
    }
    return first;
  }

  /* Normal native slide-out without a date. Returns true if something was opened. */
  function openUndated(b) {
    try { window.xola.checkout(buttonData(b)); return true; } catch (e) {}
    var el = findPageButton(b.exp);
    if (el) { try { el.click(); return true; } catch (e2) {} }
    return false;
  }

  function check() {
    var b = parseHash();
    if (!b) return;
    var token = ++pending, waited = 0;
    (function tick() {
      if (token !== pending) return;
      if (xolaReady()) {
        var dated = b.date && waited < DATED_WAIT_MS;
        if (dated) {
          try { openDated(b); } catch (e) { openUndated(b); }
        } else {
          openUndated(b);
        }
        clearHash();
        return;
      }
      waited += STEP_MS;
      if (waited >= GIVE_UP_MS) { clearHash(); return; } /* Xola never loaded: leave page as-is */
      setTimeout(tick, STEP_MS);
    })();
  }

  window.addEventListener('hashchange', check);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', check); else check();
})();
